module.exports = __webpack_public_path__ + "static/media/share.a8a3cb70.svg";